import React from "react";
import SitePage from "../SitePage";
import { Zap, Flame, Sword, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const openChat = () => window.dispatchEvent(new CustomEvent("djk:open-chat"));

export default function ManifestoPage() {
  return (
    <SitePage
      testId="manifesto-page"
      breadcrumb="Brand"
      breadcrumbLabel="Manifesto"
      eyebrow="MANIFESTO / 宣言"
      title="Non vendiamo"
      accent="pupazzi"
      subtitle="Da Viareggio, dal 2002. Silvano e Filippo, padre e figlio, cercano gli stessi personaggi che li tenevano svegli la notte da ragazzini — e li portano nella tua mensola."
    >
      <div className="space-y-14 text-zinc-300 leading-relaxed">
        <div className="border-l-4 border-yellow-400 pl-6">
          <div className="font-jp text-yellow-400 text-sm tracking-widest mb-3">01 — L&apos;ORIGINE</div>
          <h2 className="font-heading uppercase text-3xl text-white mb-4">Un banchetto, una scommessa</h2>
          <p>
            Nel 2002 partiamo con un bancale al mercato di Viareggio. Duecento pezzi in tutto, tre editori, un sogno preso troppo sul serio:
            trattare le action figure come le trattavamo da bambini — <span className="text-yellow-400">roba sacra</span>.
            Ventitre anni dopo la logica non è cambiata. Solo il numero di scaffali.
          </p>
        </div>

        <div className="border-l-4 border-yellow-400 pl-6">
          <div className="font-jp text-yellow-400 text-sm tracking-widest mb-3">02 — LE REGOLE</div>
          <h2 className="font-heading uppercase text-3xl text-white mb-4">Cosa entra in bottega</h2>
          <ul className="space-y-4">
            {[
              { icon: Sword, title: "Solo pezzi con licenza", text: "Niente cloni asiatici da bazar, niente KO. Se sull&apos;etichetta non c&apos;è il bollino ufficiale, non entra." },
              { icon: Flame, title: "Solo editori che rispettiamo", text: "Bandai, Kotobukiya, ABYstyle, Banpresto, Prime 1, First 4 Figures, McFarlane. Se una casa taglia gli angoli, la salutiamo." },
              { icon: Zap, title: "Numerati, quando serve", text: "Le edizioni limitate arrivano già col numero. Se leggiamo 200/500 sulla scatola, ci fidiamo. Se non lo leggiamo, non la chiamiamo &quot;limitata&quot;." },
            ].map(({ icon: Icon, title, text }) => (
              <li key={title} className="flex gap-4 items-start bg-zinc-900/40 border border-zinc-800 p-5">
                <div className="bg-yellow-400 text-black p-2 shrink-0">
                  <Icon className="w-5 h-5" strokeWidth={3} />
                </div>
                <div>
                  <div className="font-heading uppercase text-lg text-white mb-1">{title}</div>
                  <div className="text-zinc-400 text-sm" dangerouslySetInnerHTML={{ __html: text }} />
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="border-l-4 border-yellow-400 pl-6">
          <div className="font-jp text-yellow-400 text-sm tracking-widest mb-3">03 — LA PROMESSA</div>
          <h2 className="font-heading uppercase text-3xl text-white mb-4">Foto vera, imballo vero, prezzo onesto</h2>
          <p>
            Le foto sui prodotti sono quelle che fai tu quando apri la scatola: nessun render, nessun photoshop pesante.
            L&apos;imballaggio è quello che ci mette Bandai — noi sopra ci mettiamo lo scotch e la firma del corriere.
            Il prezzo è quello di listino ufficiale, mai gonfiato. Se costa meno del solito, è perché la fabbrica ha stampato di più, non perché ti stiamo fregando.
          </p>
        </div>

        <div className="border-t-2 border-zinc-800 pt-10 text-center">
          <div className="font-jp text-yellow-400 text-sm tracking-widest mb-4">— 大太とジャック —</div>
          <p className="text-zinc-500 italic mb-8 max-w-xl mx-auto">
            &quot;La collezione non è un investimento. È un modo di ricordarti chi eri quando avevi dieci anni e la tv accendeva Ken il Guerriero.&quot;
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/shop" data-testid="manifesto-cta-shop" className="skew-btn bg-yellow-400 text-black font-heading uppercase text-sm px-6 py-3 border-2 border-yellow-400 hover:bg-black hover:text-yellow-400 transition inline-flex items-center gap-2">
              <span>Vai allo shop <ChevronRight className="inline w-4 h-4" strokeWidth={3} /></span>
            </Link>
            <button data-testid="manifesto-cta-chat" onClick={openChat} className="skew-btn border-2 border-white text-white font-heading uppercase text-sm px-6 py-3 hover:bg-white hover:text-black transition">
              <span>Scrivici</span>
            </button>
          </div>
        </div>
      </div>
    </SitePage>
  );
}
